<template>
    <img src="@/assets/logo.svg" alt="Roeland Dev">
</template>

<script>
export default {
    name: "AppHeader",
    props: {}
};
</script>